export var SagaMode;
(function (SagaMode) {
    SagaMode["RESTART_ON_REMOUNT"] = "@@saga-injector/restart-on-remount";
    SagaMode["DAEMON"] = "@@saga-injector/daemon";
    SagaMode["ONCE_TILL_UNMOUNT"] = "@@saga-injector/once-till-unmount";
})(SagaMode || (SagaMode = {}));
